<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <!-- <el-button type="primary" @click="division_add()">新增</el-button> -->
    <el-form  class="form_cls" :inline="true" v-if="buttonList != null && buttonList.length > 0" :model="filters" @submit.native.prevent>
      <el-form-item label="">
        <el-input v-model="filters.name" placeholder="名称"></el-input>
      </el-form-item>
      <!-- <el-form-item label="医院编码">
        <el-input v-model="filters.bwacctnumber" placeholder="医院编码"></el-input>
      </el-form-item> -->
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button :type="
            item.Func &&
            (item.Func.toLowerCase().indexOf('handledel') != -1 ||
              item.Func.toLowerCase().indexOf('stop') != -1)
              ? 'danger'
              : 'primary'
          " v-if="!item.IsHide" @click="callFunc(item)">{{ item.name }}</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div class="table_top_div">
        <div>
    <el-table border :max-height="tableHeight" :data="users" row-key='ID'  :header-cell-style="{'text-align':'center','color':'#6170d7','backgroundColor':'#F5F7FA'}" :cell-style="{'text-align':'center'}" highlight-current-row @current-change="selectCurrentRow" v-loading="listLoading" @selection-change="selsChange"   >
      <!-- <el-table-column sortable type="selection" width="50">
      </el-table-column>-->
     <el-table-column type="index" width="80">
        <template slot="header" slot-scope="{}">
          <span style="padding: 8px 0">序号 
           <span class="caret-wrapper" style="width:0px"></span>
            </span>
          <!-- <span class="caret-wrapper" style="padding-top: 0px"></span> -->
        </template>
      </el-table-column>
      <!-- <el-table-column sortable prop="ID" width="" label="ID"></el-table-column> -->
      <el-table-column sortable prop="Name" width="" label="名称"></el-table-column>
      <!-- <el-table-column sortable prop="Code" width="" label="District Code"></el-table-column> -->
      <el-table-column sortable prop="TypeStr" width="" label="区域类型">
      </el-table-column>
      <el-table-column label="操作" width="160">
        <template slot="header" slot-scope="{}">
          <span style="padding: 8px 0">操作 
           <span class="caret-wrapper" style="width:0px"></span>
            </span>
        </template>
        <template scope="scope">
          <el-link type="primary" @click="handleEdit(scope.row)">
            <i class="el-icon-edit"></i>编辑
          </el-link>
        </template>
      </el-table-column>
    </el-table>
        </div>
    <!--工具条-->
   <!-- <div class="toolbar_div">
        <el-col :span="24" class="toolbar">
         <el-pagination :background='true' layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="50" :total="total" style="float: right"></el-pagination>
        </el-col>
    </div> -->
        </div>
        <el-dialog
        :title="titles"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <el-form ref="form" :model="form" :rules="editFormRules" label-width="80px" label-position="left">
             <el-form-item v-if="titles == '新增'" label="区域上级" prop="large_small">
            <!-- <el-select :disabled='HCO_IF == "CK" || HCO_IF == "EDIT"' v-model="form.sales_region_small" clearable placeholder="请输入">
              <el-option label="11" :value="1"></el-option>
            </el-select> -->
            <el-cascader
            :disabled='HCO_IF == "CK" || HCO_IF == "EDIT"'
                v-model="form.large_small"
                :options="Employee_list"
                style="width:100%"
                :props="{ value: 'ID', label: 'Name',checkStrictly: true}"
                @change="large_small_change"></el-cascader>   
          </el-form-item>
            <el-form-item label="名称" prop="Name">
                <el-input v-model="form.Name" placeholder="请输入"></el-input>
            </el-form-item>
            <!-- <el-form-item label="District" prop="Code">
                <el-input v-model="form.Code" placeholder="请输入"></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="区域类型" prop="Type">
                <el-select  v-model="form.Type" style="width:100%" placeholder="请选择">
                <el-option label="大区" :value="0"></el-option>
                <el-option label="小区" :value="1"></el-option>
              </el-select>
            </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="submit_node('form')">确 定</el-button>
        </span>
        </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  EmployeeRegionGetEmployeeRegionTrees,
  EmployeeRegionUpdate,
  store_data_Reback_Store,
  member_overrun_ExportExcel,
  EmployeeRegionAdd
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data () {
    return {
        Employee_list:[],
         tableHeight:0,
        editFormRules: {
        Name: [{ required: true, message: '请输入', trigger: 'blur' }],
        Type: [{ required: true, message: '请选择', trigger: 'blur' }],
        large_small: [{ required: true, message: '请选择', trigger: 'blur' }],
      },
      form: {},
      titles: '详情',
      dialogVisible: false,
      SalesOperation_if: false,
      edit_if_2: false,
      edit_if: true,
      buttonList: [],
      managercode_list: [],
      currentRow: null,
      filters: {
        pageSize: 50
      },
      users: [],
      statusList: [
        { LinkUrl: "激活", value: true },
        { LinkUrl: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
    };
  },
  methods: {
    large_small_change (e) {
        // if(e.length)
         this.form.Pid = e[e.length-1]
      this.form.ID = e[e.length-1]
    },
    async submit_node(formName){
         this.$refs[formName].validate(async (valid) => {
        if (valid)
        {    
            console.log(this.titles)
            if(this.titles =='新增'){
             var {data} = await EmployeeRegionAdd (this.form)
            }else{
             var {data} = await EmployeeRegionUpdate (this.form)
            }
          
          if (data.status == 200)
          {
            this.$message({
              message: data.msg,
              type: "success",
            });
            // this.$router.push(this.$route.query.back_url)
            this.getModules_search()
            this.dialogVisible =false
          } else
          {
            this.$message({
              message: data.msg,
              type: "error",
            });
          }
        } else
        {
          return
        }
      })
    },
    handleClose (done) {
      done();
    },
    ExportAccount () {
      // let para = this.filters
      var organization_id = localStorage.getItem("organization_id");
      let para = {
        organization_id: organization_id
      };
      //  para.account_manager = para.account_manager.toString()
      //  window.open("​/api​/store_data​/ExportStore?")
      member_overrun_ExportExcel(para).then((res) => {
        //window.open("http://47.103.87.196:8082" + res.data.msg);
        window.location.href = res.data.msg;
      });
    },
    selectCurrentRow (val) {
      this.currentRow = val;
      console.log(val)
    },
    callFunc (item) {
      this[item.Func].apply(this, item);
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
    },
    handleCurrentChange (val) {
      this.page = val;
      this.getModules();
    },
    getModules_search () {
      this.page = 1;
      this.getModules();
    },
    //获取用户列表
    getModules () {
      let para = this.filters;
      para.page = this.page;
      console.log(para);
      // return
      //   let para = {
      //     page: this.page,
      //     key: this.filters.key
      //   };
      this.listLoading = true;
      EmployeeRegionGetEmployeeRegionTrees(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response;
        this.listLoading = false;
      });
    },
    //删除
    handleDel (ids) {
      console.log(ids);
      this.$confirm("确认停用该区域吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          
        })
        .catch(() => { });
    },
    handleWithdraw (id) {
      // 撤回
      store_data_Reback_Store("store_id=" + id).then((res) => {
        if (res.data.success)
        {
          this.$message({
            message: "撤回成功",
            type: "success",
          });
          this.getModules();
        } else
        {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    handledetails: function (e) {
      this.$router.push({
        path: "/Employee/Employee_details",
        query: {
          id: e.ID,
          type: "CK",
          back_url: '/Employee/Employee_list'
        },
      });
    },
    handleAdd () {
        if (typeof this.$refs['form'] !== "undefined")
      {
        this.$refs['form'].resetFields();
      }
      this.form={}
        // console.log(this.currentRow)
        // if(!this.currentRow){
        // this.$message({
        //     message:'请选择上级',
        //     type: "error",
        //   });
        //   return
        // }
    //   this.form = {}
    //   this.form.Pid = this.currentRow.Pid
    //   this.form.Pid = this.currentRow.ID
      this.titles = '新增'
      this.dialogVisible = true
    },

    //编辑
    handleEdit: function (e) {
        if (typeof this.$refs['form'] !== "undefined")
      {
        this.$refs['form'].resetFields();
      }
         this.titles = '编辑'
        this.form = {}
        this.form = e
        this.dialogVisible = true
    },
    handledetails_SalesOperation: function (ids, progress, outletnumber__c) {
      // this.details_tag('我的门店2')
      this.$router.push({
        path: "/StoreManage/add_store",
        query: {
          id: ids,
          type: "store_ck",
          progress: progress,
          approval_type: "store",
          outletnumber__c: outletnumber__c,
          list_SalesOperation: 1
        },
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
      console.log(sels)
    },
    //localStorage 存储数组对象的方法
    saveObjArr (name, data) {
      localStorage.setItem(name, JSON.stringify(data));
    },

    //localStorage 获取数组对象的方法
    getObjArr (name) {
      return JSON.parse(window.localStorage.getItem(name));
    },
    details_tag (name) {
      var router_list = this.getObjArr("router");
      for (let i in router_list)
      {
        for (let s in router_list[i].children)
        {
          //  console.log(999)
          if (router_list[i].children[s].id == "175")
          {
            //  console.log(999)
            router_list[i].children[s].name = name;
            router_list[i].children[s].meta.title = name;
            console.log(router_list[i].children[s].name);
            this.saveObjArr("router", router_list);
            console.log(this.getObjArr("router"));
          }
        }
      }
      //  this.getObjArr('router') = router_list
      console.log(router_list);
    },
     async EmployeeRegionGetEmployeeRegionTrees_fn(){
        const {data} = await EmployeeRegionGetEmployeeRegionTrees()
        this.Employee_list = data.response
    },
  },
  mounted () {
   this.$nextTick(()=>{
        	      this.tableHeight = window.innerHeight - 250;
		})
    console.log(this.getObjArr("router"));
    this.getModules();
    this.EmployeeRegionGetEmployeeRegionTrees_fn()
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    if (this.buttonList) {
        if (
          this.buttonList.filter(function (e) {
            return e.name == "编辑" || e.name == "停用";
          }).length != 0
        ) {
          this.PLGX_IF = true;
        }
        this.buttonList = this.buttonList.filter(function (e) {
          return e.name != "编辑";
        })
        this.buttonList = this.buttonList.filter(function (e) {
          return e.name != "停用";
        })

      };

  },
};
</script>

<style scoped>
</style>
